import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.29 20c7.547 0 11.675-6.156 11.675-11.495 0-.175 0-.349-.012-.522A8.278 8.278 0 0 0 22 5.892a8.29 8.29 0 0 1-2.357.635 4.066 4.066 0 0 0 1.804-2.234 8.303 8.303 0 0 1-2.605.98 4.154 4.154 0 0 0-4.93-.794 4.022 4.022 0 0 0-2.063 4.48 11.712 11.712 0 0 1-8.457-4.222 4.005 4.005 0 0 0 1.27 5.393A4.121 4.121 0 0 1 2.8 9.624v.052c0 1.923 1.377 3.58 3.292 3.96a4.16 4.16 0 0 1-1.853.07c.538 1.645 2.078 2.772 3.834 2.805A8.316 8.316 0 0 1 2 18.185a11.75 11.75 0 0 0 6.29 1.812",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }